import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toastError, toastSuccess, toastWarning } from "../Common/ToastAlert";
import { publishNewsFeed } from "../../api/network";
import { toast } from "react-toastify";

const PublishFeed = ({
  show,
  onHide,
  data,
  setIsOpenPublishFeed,
  refetchData,
}) => {
  const [loading, setLoading] = useState(false);

  const publishFeedData = async (data) => {
    if (!data?.id) return;
    const dataToPublish = {
      id: data.id,
    };
    try {
      setLoading(true);
      const onPublish = await publishNewsFeed(dataToPublish);
      if (onPublish.status === 200) {
        setLoading(false);
        toast.success("Feed has been published", toastSuccess());
        refetchData();
        setIsOpenPublishFeed(false);
      } else {
        setLoading(false);
        toast.error(
          "Hmm. Something doesn't seem right. Try refreshing or logging in again.",
          toastError()
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Publish Error:", error);
      const msg =
        error?.response?.data?.message ||
        "Failed to publish feed. Please try again.";
      toast.warning(msg, toastWarning());
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      className="dsm-modal-popup"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Publish News Feed?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to publish this feed?</p>
        <p>Once published, it cannot be edited.</p>
      </Modal.Body>
      <Modal.Footer>
        {/* Check data existence safely */}
        {!data?.active && (
          <>
            <button
              type="button"
              className="dsm-btn-danger-light"
              onClick={onHide}
              disabled={loading}
            >
              Cancel
            </button>

            <button
              type="button"
              className="dsm-btn-primary"
              onClick={() => publishFeedData(data)}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" variant="light" />{" "}
                  Publishing...
                </>
              ) : (
                "Publish"
              )}
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PublishFeed;
